import React from 'react'
import { Link } from 'react-router'

import Container from '../Container/Container'

const GenericError: React.FC = (): React.ReactElement => {
  return (
    <Container>
      <h1>Something went wrong</h1>
      <p>
        We're a little bit lost.{' '}
        <Link to="/" viewTransition>
          Click here
        </Link>{' '}
        to return to the homepage.
      </p>
    </Container>
  )
}

export default GenericError
